import { type FC } from "react";

const LoadingState: FC = () => {
  return (
    <div
      className="flex w-full flex-col items-center gap-4 py-6"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="font-bold elm-p4 text-center text-[#00262B]">
        Searching...
      </span>
      <div
        className="size-8 animate-spin rounded-full border-[3px] border-[#00262B] border-t-transparent"
        aria-hidden
      />
      <span className="elm-p2 text-center text-putty-700 text-balance">
        We&apos;re loading your search results.
      </span>
    </div>
  );
};

export default LoadingState;
